export default {
  InactiveColumn: {
    True: 'Ngừng kích hoạt',
    False: 'Đang sử dụng',
  },
};
